<template>
  <a-modal
    title="Form Changes"
    :visible="modalEdit"
    @ok="handleModalEditOk"
    @cancel="handleCancel"
    :maskClosable="false"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        Cancel
      </a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleModalEditOk">
        OK
      </a-button>
    </template>
    <a-form :form="formEdit">
      <a-form-item label="PP Detail">
        <a-select
          showSearch
          class="select-between"
          placeholder="Select PP"
          @change="handlePP"
          v-decorator="[
            'id_pp_dtl',
            {
              rules: [{ required: true }],
              initialValue: data.id_pp_dtl,
            },
          ]"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="item in ppList" :key="item.id_pp_dtl">
            <div class="elipsdiv">
              <div class="elipsdiv-mouseover-label1" >
                <h4>{{ item.nama_barang }}</h4>
                  <small>| </small>
                  <small>{{ item.kode_anggaran }}</small>
                  <small> | </small>
                  <small>{{
                    formatCurrency(item.currency, item.nilai_dtl_pp)
                      .replace(",00", "")
                  }}</small>
              </div>
            </div>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Detail Name">
        <a-input
          v-decorator="[
            'detail_name',
            { rules: [{ required: true }], initialValue: data.deskripsi },
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Date Usage">
        <a-date-picker
          placeholder="Select Date"
          :format="getDefaultDateFormat"
          v-decorator="[
            'tanggal_pemakaian',
            {
              rules: [{ required: true }],
              initialValue: moment(data.tanggal_pemakaian),
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="Credit">
        <a-input-number
          type="number"
          class="m-width-full m-text-align-right"
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
          v-decorator="[
            'kredit',
            { rules: [{ required: true }], initialValue: data.kredit },
          ]"
        />
      </a-form-item>
      <a-row :gutter="12">
        <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
          <a-form-item label="Is Commission?">
            <a-radio-group
              v-decorator="[
                'iscommision',
                { rules: [{ required: false }], initialValue: data.iscommision },
              ]"
              @change="handleOptionCommission"
              :disabled="EnCommission"
              button-style="solid"
            >
              <a-radio-button value="1"> Yes </a-radio-button>
              <a-radio-button value="0"> No </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
          <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
            <a-form-item label="With Note?" :hidden="true">
            <a-radio-group
              v-decorator="[
                'without_note',
                { rules: [{ required: false }], initialValue: data.without_note },
              ]"
              button-style="solid"
            >
              <a-radio-button value="0"> Yes </a-radio-button>
              <a-radio-button value="1"> No </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item label="Upload Transaction Document">
        <a-upload
          :showUploadList="true"
          :fileList="doctransfiles"
          :beforeUpload="beforedoctransUpload"
          :remove="handledoctransRemove"
          v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
        >
          <a-button>
            <a-icon type="upload" />&nbsp;Select File
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "modalKlaimPp",
  props: {
    modalEdit: Boolean,
    data: {},
    ppList: Array,
    reportingList: Array,
  },
  mixins: [CurrencyFormat, GlobalMethod],
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getAuth", "getScreen"]),
  },
  data() {
    return {
      selectedPp: [],
      sppd: [],
      confirmLoading: false,
      EnCommission: false,
      Viwithout_note: false,
      doctransfiles: [],
    };
  },
  mounted(){
      // this.EnCommission = this.data.EnCommission;
      this.Viwithout_note = this.data.Viwithout_note;
      this.doctransfiles = this.data.doctransfiles;
  },
  beforeCreate() {
    this.formEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    handleCancel(e) {
      Event.$emit("modalCancel", false);
      Event.$emit("fetchSppd", false);
      this.formEdit.resetFields();
    },
    submit(values) {
      let url =
        this.data.type === "revised"
          ? "klaim_biaya_pp/revisi_detil_pemakaian_edit"
          : "klaim_biaya_pp/detil_pemakaian_edit";

      let addData = new FormData();
      addData.append("id", this.data.id);
      addData.append("tanggal_pemakaian", values.tanggal_pemakaian.format("YYYY-MM-DD"));
      addData.append("pp_dtl", values.id_pp_dtl);
      addData.append("deskripsi", values.detail_name);
      addData.append("kredit", values.kredit);
      addData.append("iscommision", values.iscommision);
      // addData.append("without_note", values.without_note);
      addData.append("without_note", "1");

      if (this.doctransfiles && this.doctransfiles.length > 0) {
        this.doctransfiles.forEach((file) => {
          addData.append("file_upload", file);
        });
      }
      this.confirmLoading = true;
      axios({
        method: "post",
        url: this.$serviceUrl + url,
        processData: false,
        data: addData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          // "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.formEdit.resetFields();
          console.log("submit")
          Event.$emit("modalCancel", false);
          Event.$emit("fetchPemakaian", true);
          Event.$emit("fetchPp", true);
          this.confirmLoading = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          //console.log(responses);
          this.displayMessageValue("error-other", responses.message);
          this.confirmLoading = false;
        });
    },
    handleModalEditOk() {
      this.formEdit.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        } 

        if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Usage date can't exceed today!");
          return;
        }

        this.handlePP(values.id_pp_dtl);
        if (parseFloat(values.kredit) > parseFloat(this.selectedPp[0].saldo_anggaran)) {
          this.displayMessage("over-kredit");
          this.confirmLoading = false;
          return;
        }

        const selected = this.selectedPp[0];
        const tempDataSelected = this.data;

        let indexTempSelected = this.reportingList.findIndex(
          (i, idx) => tempDataSelected.id == i.id
        );

        const datalist = this.reportingList.filter(function(item, idx) {
          if (
            item.deskripsi.toLowerCase() === values.detail_name.toLowerCase()
          ) {
            return item;
          }
        });
        
        // if (
        //   moment(tempDataSelected.tanggal_pemakaian).format("DD-MM-YYYY") ==
        //     moment(values.tanggal_pemakaian).format("DD-MM-YYYY") &&
        //   tempDataSelected.kredit == values.kredit &&
        //   values.detail_name == tempDataSelected.deskripsi &&
        //   values.id_pp_dtl == tempDataSelected.id_pp_dtl
        // ) {
        //   this.displayMessage("form-duplicate");
        //   return;
        // } else {
          let dataUnSelected = this.reportingList.filter(
            (i, idx) => idx != indexTempSelected
          );
          let dataFoundSameDeskripsi = dataUnSelected.filter(
            (i) => values.detail_name == i.deskripsi
          );

          // if (dataFoundSameDeskripsi.length === 0) {
            this.submit(values);
          // } else {
          //   this.displayMessage("form-duplicate");
          //   return;
          // }
        // }
      });
    },
    handlePP(e) {
      this.selectedPp = this.ppList.filter(
        (obj) => obj.id_pp_dtl.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      let selectedumDtl = _.filter(this.ppList, { id_pp_dtl: e });
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        // this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        // this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.formEdit.setFieldsValue({
            without_note: "1",
        });
      });
    },
    handleChangeumDtl(val){
      let selectedumDtl = _.filter(this.data.ppdetillist, { id_um_dtl: val });
      //console.log(selectedumDtl,this.ppdetillist);
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        // this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        // this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
     beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
};
</script>

<style lang="less">
.ant-select-selection-selected-value{
    width:100%!important;
    .elipsdiv{
      .elipsdiv-mouseover-label1:hover{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
